/**
 * Util for selecting a formatted string from a Date or Timestamp column, default format is YYYY-MM-DD.
 * @param columnName name of the column to format
 * @param formatString (optional) format string. See https://duckdb.org/docs/stable/sql/functions/dateformat.html#format-specifiers
 * @returns snippet to include in a duckdb query (ex.`SELECT ${formattedDateColumn(colName)} FROM ...`)
 */
export const formattedDateColumn = (
  columnName: string,
  formatString?: string
) => {
  return `strftime(${columnName}, '${formatString ?? '%Y-%m-%d'}')`;
};
